import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <div className="not-found">
    <h1 className="not-found__code">404</h1>
    <p className="not-found__message">Page not found</p>
    <Link className="button" to="/">
      Go Home
    </Link>
  </div>
);

export default NotFoundPage;
